<template>
  <div class="animated fadeIn" style="overflow:scroll;">
    <b-card>
      <div slot="header">
        Jadwal Exam Kresna
      </div>
      <table class="table">
        <thead>
          <tr>
            <th>#</th>
            <th>Nama</th>
            <th>Periode</th>
            <th>Tipe</th>
            <th>Tempat</th>
            <th>Waktu</th>
            <th>Status</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(rowexam,key) in data_exam" :key="key">
            <td>{{key+1}}</td>

            <td>{{rowexam.dataexam.nama}}</td>
            <td>{{rowexam.dataexam.periode}}</td>
            <td><b-badge variant="primary" v-if="rowexam.dataexam.tipe=='1'">Umum</b-badge>
              <b-badge variant="warning" v-if="rowexam.dataexam.tipe=='2'">Terprogram</b-badge></td>
            <td>{{rowexam.dataexam.tempat}}</td>
            <td>{{rowexam.dataexam.waktu}}</td>
            <td>
              <b-badge variant="success" v-if="rowexam.dataexam.status=='Y'">Aktif</b-badge>
              <b-badge variant="danger" v-if="rowexam.dataexam.status=='N'">Selesai</b-badge>
            </td>
            <td class="text-center">
              <button
              v-if="rowexam.status=='APPLY'&&rowexam.userexam.status=='DITERIMA'&&rowexam.dataexam.status=='N'"
              class="btn btn-success btn-sm"
              style="margin:3px;"
              @click="link(rowexam.userexam._id)"
            >LIHAT NILAI</button>
            <button
              v-if="rowexam.status=='APPLY'&&rowexam.userexam.status=='DITERIMA'&&rowexam.dataexam.status=='Y'"
              class="btn btn-primary btn-sm"
              style="margin:3px;"
              @click="link(rowexam.userexam._id)"
            >CETAK ID CARD</button>

              <button
                v-if="rowexam.status=='NOT_APPLY'&&rowexam.dataexam.status=='Y'"
                class="btn btn-primary btn-sm"
                style="margin:3px;"
                @click="apply(rowexam.dataexam._id)"
              >DAFTAR UJIAN</button>

              <button
              v-if="rowexam.status=='APPLY'&&rowexam.userexam.status=='PENGAJUAN'"
              class="btn btn-warning btn-sm"
              style="margin:3px;"
            >PENGAJUAN</button>
            <button
              v-if="rowexam.status=='APPLY'&&rowexam.userexam.status=='DITOLAK'"
              class="btn btn-danger btn-sm"
              style="margin:3px;"
            >DITOLAK</button>

            </td>
          </tr>
        </tbody>
      </table>
    </b-card>

  </div>
</template>

<script>
import { API_SERVER } from "@/config";
import { CALLAPILOGIN } from "@/functions";
import Vuetable from "vuetable-2";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo";
export default {
  name: "Dataexam",
  data() {
    return {
      exam: {
        nama: "",
        deskripsi: "",
        periode: "",
        tipe: 1,
        tempat: "",
        status: "Y",
        waktu: "",
      },
      data_exam: [],
      jumlah: 0,
      errors: [],
      list_periode:[],
      loadingpost: false,
      modalstatus: "",
      readonly: {
        id: ""
      }
    };
  },
  mounted() {
    this.getdataexamuser();
  },
  methods: {
    clickCallback (pageNum){
      console.log(pageNum)
      this.page=pageNum;
      this.getdataexamuser();
    },
    getallperiode() {
      // console.log(datanya_percategory_id);
      CALLAPILOGIN.get("program/periode_jadwal")
        .then(response => {
          this.list_periode = response.data.data;
          console.log(this.data_per_category);
        })
        .catch(e => {
          swal("Error", "Gagal Mengambil Data", "error", {
            buttons: true,
            timer: 3000
          });
        });
    },
    getdataexamuser() {
      let id = localStorage.getItem('X-Id')

      CALLAPILOGIN.get("exam/listexamuser/"+id)
        .then(response => {
          this.data_exam = response.data.data;
          this.last_page = response.data.last_page;
          this.from = response.data.from;
          this.jumlah = response.data.total;
          console.log(response);
        })
        .catch(e => {
          // this.$router.push({ path: "/user/404" })
          this.errors.push(e);
        });
    },
    showmodalku(status) {
      this.modalstatus = status;
      this.$refs.modal.show();
    },
    closemodalku() {
      this.resetdata();
      this.$refs.modal.hide();
    },
    resetdata() {
      this.exam.nama = "";
      this.exam.status = "";
    },
    apply(idexam) {
      var iduser = localStorage.getItem('X-Id')
      swal({
        title: "Are you sure?",
        text: "Apakah Anda Yakin Ingin Mendaftar Exam?",
        icon: "warning",
        buttons: true,
        dangerMode: true
      }).then(willDaftar => {
        if (willDaftar) {
              var data_post =[]
                data_post.push({
                  idexam:idexam,
                  iduser:iduser,
                })
                this.loadingpost = true;
                let PushData;
                PushData = CALLAPILOGIN.post(`/exam/addsiswa`, data_post);
                PushData.then(res => {
              swal("Berhasil Mengajukan Exam", "Berhasil Mendaftar Exam, tunggu admin mengkonfirmasi data anda.", {
                    buttons: true,
                    timer: 3000
                  });
                this.getdataexamuser();
                }).catch(e => {
                  swal("Error", "Gagal Mendaftar Exam, Hubungi admin.", "error", {
                    buttons: true,
                    timer: 3000
                  });
                  console.log(e.response ? e.response : e);
                });
        }
      });
    },link(id){
      console.log(id);
      this.$router.push({ path: "laporan_exam/"+id })
    },link_nilai(id){
      console.log(id);
      this.$router.push({ path: "nilai_user_exam/"+id })
    },
  }
};
</script>
